import { makeStyles, Theme } from '@material-ui/core/styles';

const styles = makeStyles(({ spacing, palette, breakpoints, variables }: Theme) => ({
  alertDialogDescription:{
    marginBottom:'24px',
    wordBreak:'break-word'
  },
  buttonsContainer:{
    display:'flex',
    flexDirection: 'row-reverse',
    ['@media only screen and (max-width:1024px)']: {
        flexDirection:'column',
        '& button:nth-of-type(1)':{
          marginBottom:variables?.spacingE
        }
    }
  },
  paper: {
    padding:variables?.spacingF,
    justifyContent: 'center',
    textAlign: 'left',
    boxSizing: 'border-box',
    textSizeAdjust: '100%',
    '-webkit-text-size-adjust': '100%',
    [breakpoints.up('sm')]: {
      maxWidth: '408px',
      borderRadius: '2px',
      width:'100%',
      boxShadow: '0 0 8px 0 rgba(0, 0, 0, 0.16)'
    },
    [breakpoints.down('xs')]: {
      width:'100%'
    },
    [`${breakpoints.only(
      'sm'
    )} and (orientation: landscape) and (pointer: coarse)`]: {
      maxWidth: 'none',
      boxShadow: 'none',
      padding: `${spacing(4)}px ${spacing(3)}px`,
      maxHeight:'unset !important',
      alignSelf:'end'
    },
  },
  title: {
    marginTop: '-12px',
    marginBottom: '20px',
    width:'95%'
  },
  actionButton: {
    boxShadow: 'none',
    padding: `10px ${spacing(2)}px`,
    margin: 'auto',
    display: 'block',
    '&:first-child': {
      marginBottom: `${spacing(2)}px`,
    },
    [breakpoints.up('sm')]: {
      maxWidth: '400px',
    },
  },
  actionButtonSubmit: {
    borderRadius: 0,
  },
  actionButtonCancel: {
    marginRight:'16px',
  },
  closeButton: {
    position: 'absolute',
    top: `${spacing(1)}px`,
    right: `${spacing(1)}px`,
  },
  closeButtonIcon: {
    width: `${spacing(2)}px`,
    height: `${spacing(2)}px`,
  },
}));

export default styles;
